import type { ReactNode } from 'react';
import React from 'react';

import cx from '../../../utils/classNames';
import toCamelCase from '../../../utils/toCamelCase';

import { ButtonSize } from '../../../types/variants';

import styles from '../textField.module.scss';

/** Custom props */
export type TextFieldLeadingIconProps = {
  /** The content of the component */
  children?: ReactNode;
  /** Custom class to overwrite default styling if needed */
  className?: string;
  /** Controls the size of the textfield */
  size?: ButtonSize;
};

export function LeadingIcon(props: TextFieldLeadingIconProps) {
  const { children, className, size = ButtonSize.Medium } = props;

  const classNames = cx(
    styles[toCamelCase('textField', 'leadingIcon')],
    styles[toCamelCase('textField', 'leadingIcon', size)],
    className,
  );

  return (
    <span className={classNames} data-testid="textField-leadingIcon">
      {children}
    </span>
  );
}

export default LeadingIcon;
